import { render } from "./ApprovedDeliveries.vue?vue&type=template&id=2e34126a"
import script from "./ApprovedDeliveries.vue?vue&type=script&lang=js"
export * from "./ApprovedDeliveries.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__